import React, { useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const IMPERSONATION_BANNER_HEIGHT_PROPERTY = '--impersonation-banner-height';

export const ImpersonationBanner: React.FC = () => {
  const { originalAdminUser, user, stopImpersonate } = useAuth();
  const navigate = useNavigate();
  const bannerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = bannerRef.current;
    if (!element) {
      document.documentElement.style.setProperty(IMPERSONATION_BANNER_HEIGHT_PROPERTY, '0px');
      return;
    }

    const updateHeight = (): void => {
      document.documentElement.style.setProperty(
        IMPERSONATION_BANNER_HEIGHT_PROPERTY,
        `${element.offsetHeight}px`,
      );
    };

    updateHeight();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateHeight);
    observer?.observe(element);

    return () => {
      observer?.disconnect();
      document.documentElement.style.setProperty(IMPERSONATION_BANNER_HEIGHT_PROPERTY, '0px');
    };
  }, [originalAdminUser, user]);

  if (!originalAdminUser || !user) {
    return null;
  }

  const handleStopImpersonate = async () => {
    await stopImpersonate();
    navigate('/admin/users');
  };

  return (
    <div
      ref={bannerRef}
      data-testid="impersonation-banner"
      style={{
        position: 'relative',
        width: '100%',
        flexShrink: 0,
        boxSizing: 'border-box',
        backgroundColor: '#dc2626',
        color: '#ffffff',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        zIndex: 9999,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>
          Impersonando usuario:
        </div>
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <strong>{user.email}</strong>
        </div>
        <div style={{ fontSize: '0.875rem', opacity: 0.9, whiteSpace: 'nowrap' }}>
          (Admin: {originalAdminUser.email})
        </div>
      </div>
      <Button
        onClick={handleStopImpersonate}
        variant="outline"
        style={{
          backgroundColor: '#ffffff',
          color: '#dc2626',
          borderColor: '#ffffff',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f3f4f6';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}
      >
        Dejar de impersonar
      </Button>
    </div>
  );
};
